import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { usePackage } from "../context/usePackage";
import "./PromotionExpiryNotice.css";

export default function PromotionExpiryNotice() {
  const { lastEntitlement } = usePackage();
  const [now, setNow] = useState(() => Date.now());
  const expiresAt = lastEntitlement?.promotionExpiresAt;

  useEffect(() => {
    if (!expiresAt) return;
    const timer = window.setInterval(() => setNow(Date.now()), 60_000);
    return () => window.clearInterval(timer);
  }, [expiresAt]);

  if (!expiresAt) return null;
  const expiry = new Date(expiresAt);
  const remaining = expiry.getTime() - now;
  if (!Number.isFinite(remaining) || remaining > 14 * 86_400_000) return null;
  const date = expiry.toLocaleString("en-GB", { dateStyle: "long", timeStyle: "short" });

  return (
    <aside className="promotion-expiry-notice" role="status">
      <strong>{remaining > 0 ? `Your promotional offer ends on ${date}.` : "Your promotional offer has ended."}</strong>{" "}
      {lastEntitlement?.isFamilyPromotion ? "The promotional family package will end. " : ""}
      Promotional access returns to Freemium; any separate personal package or paid upgrade is kept. Your saved data stays safe.{" "}
      <Link to="/subscriptions">Review your package</Link>
    </aside>
  );
}
